<template>
    <div class="" :class="{hidden: !loading}">
        <loading></loading>
    </div>

    <form action="" class="form form--floating-label" :class="{hidden: loading}" @submit.prevent="formSubmit" ref='form' >
        <div class="style-h2 mb-4">
            User Password
        </div>

        <div class="mb-5">
            <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.password, error: submittedOnce && errors.password}">
                <input
                        id="password-input"
                        type="password"
                        v-model="formData.password"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                        autocomplete="on"
                />
                <label for="password-input" class="absolute left-2 transition-all px-1 text-blue-gray">
                    Password
                </label>
            </div>

            <div class="text-sm mt-2" v-if="formData.password.length">
                <ul>
                    <li :class="{'text-red': passwordLengthError}">
                        - Password need to have minimum eight characters
                    </li>
                    <li :class="{'text-red': passwordOneLetterError}">
                        - Password need to have at least one letter
                    </li>
                    <li :class="{'text-red': passwordOneNumberError}">
                        - Password need to have at least one number
                    </li>
                </ul>
            </div>

        </div>


        <div class="mb-5">
            <div class="input-container input-container--floating relative h-12 " :class="{empty: !formData.confirmPassword, error: submittedOnce && errors.confirmPassword}">
                <input
                        id="confirmPassword"
                        type="password"
                        v-model="formData.confirmPassword"
                        class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
                        autocomplete="on"
                />
                <label for="confirmPassword" class="absolute left-2 transition-all px-1 text-blue-gray">
                    Confirm Password
                </label>
            </div>
            <div v-if="submittedOnce && errors.confirmPassword " class="text-red text-sm mt-2 leading-none">
                {{ errors.confirmPassword }}
            </div>
        </div>


        <div v-if="submittedOnce && errors.message" class="bg-red text-white mt-10 mb-5 px-3 py-2 rounded ">
            {{ errors.message }}
        </div>

        <div v-if="successMessage" class="bg-blue-success text-white mb-5 px-3 py-2 rounded ">
            {{ successMessage }}
        </div>

        <div class="mt-10 flex flex-col md:flex-row items-center ">
            <button type="submit" class="btn w-full md:w-auto">Update User Password</button>
        </div>
    </form>
</template>

<script charset="utf-8">

import { values, join, get, assign, pick } from 'lodash';
import Loading from '../includes/Loading.vue';
import Vuex from 'vuex';

export default {
    name: 'ProfileForm',
    data() {
        return {
            formData: {
                password: '',
                confirmPassword: ''
            },
            successMessage: '',
            loading: false,
            submittedOnce: false,

            errors: {
                password: 'Password is required',
                confirmPassword: 'Confirm password field is required'
            }
        }
    },

    components: {
        Loading
    },

    computed: {
        passwordLengthError: function () {
            return this.formData.password.length < 8;
        },
        passwordOneNumberError: function () {
            const regex= /^.*[0-9].*$/;
            return !regex.test(this.formData.password);
        },
        passwordOneLetterError: function () {
            const regex= /^.*[a-zA-Z].*$/;
            return !regex.test(this.formData.password);
        },
    },

    emits: ["submit-success"],

    watch: {
        formData: {
            handler(newVal){
                this.errors.message = '';
                this.errors.password = newVal.password ? '' : 'Password is required';
                this.errors.confirmPassword   = newVal.password == newVal.confirmPassword  ? '' : 'Confirm password is not matched';
            },
            deep: true
        }
    },

    methods: {
        ...Vuex.mapActions('profile', {
            updateUser: 'updateUser',
        }),

        formSubmit() {
            this.submittedOnce = true;
            this.errors.message = '';

            // do not submit if form has errors
            if (join(values(this.errors), '')) {
                return;
            }

            let data = {
                password: this.formData.password
            }
            this.loading = true;

            this.updateUser(data)
            .then(() => {
                this.loading = false;
                this.successMessage = 'User password has been updated';
                this.$emit('submit-success');
            })
            .catch(() => {
                this.loading = false;
                this.errors = {
                    message: 'Invalid data'
                }
            })

        },
    }
}
</script>
